<section class="container">
  <div class="header-wrapper">
    <h1>Remove Data</h1>
  </div>
  @if (!purging) {
    <div class="content-wrapper">
      <h3>Remove Record Data</h3>
      <div class="row">
        <mat-select multiple [(value)]="selectedModules" placeholder="Please select one or more modules">
          @for (module of moduleItems | async; track module) {
            <mat-option [value]="module.id">{{module.text}}</mat-option>
          }
        </mat-select>
        <a mat-raised-button class="mat-accent" [disabled]="!isRemoveRecordsButtonAvailable()" (click)="purgeRecordDataConfirm()">
          Remove Records
        </a>
      </div>
      <h3>Remove Hierarchy and All Record Data</h3>
      <p><em>Wiping the hierarchy will remove all records.</em></p>
      <div>
        <a mat-raised-button class="mat-accent" (click)="purgeHierarchyDataConfirm()">
          Remove Hierarchy
        </a>
      </div>
    </div>
  }

  @if (purging) {
    <div class="tile-wrapper">
      <mat-card>
        <mat-card-title>Purging Data from EHS for tenant</mat-card-title>
        <mat-card-subtitle>You can close this window and the task will continue in the background</mat-card-subtitle>
      </mat-card>
      <mat-card>
        <mat-card-title>Progress</mat-card-title>
        <mat-card-content>
          @if (purgingJobId) {
            <job-liveview [jobId]="purgingJobId" (finished)="jobComplete($event)"></job-liveview>
          }
        </mat-card-content>
      </mat-card>
    </div>
  }
</section>
